import ApiService from "../api.services";

const AuditService = {
  upload: async function (file, isEuEntrego) {
    try {
      const formData = new FormData();
      const fileToUpload = file.raw || file;
      formData.append('files', fileToUpload);
      if (formData.has('files')) {
        const url = isEuEntrego ? `/api/audit/upload?euentrego=true` : '/api/audit/upload';
        const response = await ApiService.postUploadData(url, formData);
        return response.data;
      } else {
        console.error('Nenhum arquivo encontrado no formData.');
        return null;
      }
    } catch (error) {
      console.error('Erro ao enviar o arquivo:', error.response ? error.response.data : error.message);
      throw error;
    }
  },
  pendencies: async function (page, body) {
    try {
      const data = {
        filter: body,
      };
      const response = await ApiService.post(
        `/api/audit/pendencies?page=${page}`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  values: async function (service, type, body) {
    try {
      const response = await ApiService.put(
        `/api/audit/values/${service}?type=${type}`,
        body
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  export: async function (body, fileType) {
    body.action = "export";
    body.fileType = fileType;
    try {
      const data = {
        filter: body,
      };
      const response = await ApiService.post(`/api/audit/pendencies`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  cardpost: async function (type) {
    try {
      const response = await ApiService.get(`/api/audit/cardpost?type=${type}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  diff: async function () {
    try {
      const response = await ApiService.get(`/api/audit/diff`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  toservice: async function (destiny, source) {
    try {
      const response = await ApiService.put(
        `/api/audit/services/${destiny}/${source}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  link: async function (cardpost, customer) {
    try {
      const response = await ApiService.put(
        `/api/audit/cardpost/${cardpost}/${customer}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  change: async function (selected, another, audit, prepost) {
    try {
      const response = await ApiService.put(
        `/api/audit/diff/${audit}/${prepost}`,
        {
          action: selected,
          cardpost: another,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  files: async function (filter) {
    try {
      const response = await ApiService.get(
        `/api/audit/files?tag=${filter.tag}&archived=${filter.archived}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  objects: async function (id, search, records, page) {
    try {
      const response = await ApiService.get(
        `/api/audit/objects/${id}?records=${records}&page=${page}&search=${search}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  findfile: async function (id) {
    try {
      const response = await ApiService.get(`/api/audit/files/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  download: async function (id) {
    try {
      const response = await ApiService.get(`/api/audit/download/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  save: async function (items) {
    try {
      const data = {
        items: items,
      };
      const response = await ApiService.post(`/api/audit`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  ignore: async function (items) {
    try {
      const data = {
        items: items,
      };
      const response = await ApiService.post(`/api/audit/ignore`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  services: async function (type) {
    try {
      const response = await ApiService.get(`/api/audit/services?type=${type}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  reprocess: async function (data) {
    try {
      const response = await ApiService.post(`/api/audit/reprocess`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  customers: async function (type) {
    try {
      const response = await ApiService.get(
        `/api/audit/customers?type=${type}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default AuditService;

export { AuditService };
